import styled from 'styled-components';
import { variables } from '../../../../styles/variables';

export const PartialMarksList = styled('ul')`
  list-style: none;
  padding: 0;
  margin: 0;
`;
export const ListItem = styled('li')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  div {
    padding-left: 5px;
  }
  em {
    color: ${variables.colorGrey};
    font-size: 1.8rem;
  }
  b {
    font-size: 2.5rem;
  }
`;

export const PartialMarkDisabled = styled('span')`
  opacity: 0.3;
`;
